import { login, logout, getInfo, refreshToken } from '@/api/login'
import { getToken, setToken, setExpiresIn, removeToken } from '@/utils/auth'
import { ElMessage } from 'element-plus'


const user = {
    state: {
      token: getToken(),
      id: '',
      name: '',
      avatar: '',
      roles: [],
      permissions: [],
      companyName:""
    },
  
    mutations: {
      SET_COMPANYNAME:(state,companyName) => {
        state.companyName = companyName
      },
      SET_TOKEN: (state, token) => {
        state.token = token
      },
      SET_EXPIRES_IN: (state, time) => {
        state.expires_in = time
      },
      SET_ID: (state, id) => {
        state.id = id
      },
      SET_NAME: (state, name) => {
        state.name = name
      },
      SET_AVATAR: (state, avatar) => {
        state.avatar = avatar
      },
      SET_ROLES: (state, roles) => {
        state.roles = roles
      },
      SET_PERMISSIONS: (state, permissions) => {
        state.permissions = permissions
      }
    },
  
    actions: {
      // 登录
      Login({ commit }, userInfo) {
        const username = userInfo.username.trim()
        const password = userInfo.password
        const code = userInfo.code
        const uuid = userInfo.uuid
        const companyCode = userInfo.companyCode
        return new Promise((resolve, reject) => {
          login(username, password, code, uuid, companyCode).then(res => {
            let data = res.data
            sessionStorage.setItem('access_token', data.access_token)
            setToken(data.access_token)
            commit('SET_TOKEN', data.access_token)
            setExpiresIn(data.expires_in)
            commit('SET_EXPIRES_IN', data.expires_in)
            resolve()
          }).catch(error => {
            reject(error)
          })
        })
      },
  
      // 获取用户信息
      GetInfo({ commit, state }) {
        return new Promise((resolve, reject) => {
          getInfo().then(res => {
            if(!res.data.permissionList){
              ElMessage.error('请联系管理员配置菜单权限');
            }

            localStorage.setItem('charactarList',JSON.stringify(res.data.permissionList))
            localStorage.setItem('company',JSON.stringify(res.data.company))

            localStorage.setItem('userid',res.data.userid)
            localStorage.setItem('nickName',res.data.username)

            localStorage.setItem('cid',res.data.companyId)  
            localStorage.setItem('companyName', res.data.company.companyName) 

            localStorage.setItem('isCompanyAdmin', res.data.isCompanyAdmin)

            commit('SET_ROLES', ['ROLE_DEFAULT'])

            resolve(res)
          }).catch(error => {
            reject(error)
          })
        })
      },
  
      // 刷新token
      RefreshToken({commit, state}) {
        return new Promise((resolve, reject) => {
          refreshToken(state.token).then(res => {
            setExpiresIn(res.data)
            commit('SET_EXPIRES_IN', res.data)
            resolve()
          }).catch(error => {
            reject(error)
          })
        })
      },
      
      // 退出系统
      LogOut({ commit, state }) {
        return new Promise((resolve, reject) => {
          logout(state.token).then(() => {
            commit('SET_TOKEN', '')
            commit('SET_ROLES', [])
            commit('SET_PERMISSIONS', [])
            removeToken()
            localStorage.clear()
            resolve()
          }).catch(error => {
            reject(error)
          })
        })
      },
  
      // 前端 登出
      FedLogOut({ commit }) {
        return new Promise(resolve => {
          commit('SET_TOKEN', '')
          removeToken()
          localStorage.clear()
          resolve()
        })
      }
    }
  }
  
  export default user